import { createApiClient } from '@delta/api-client';
import { createAdminSessionStorage, installAdminSessionRenewal } from '../auth/adminSession';
import type { CurrentUser, PlatformOperator } from '@delta/domain';
import { reportDeleteError } from '../shared/apiError';
import { Toast } from '../ui/semi';

const ACCESS_TOKEN_KEY = 'delta.access-token';
const USER_KEY = 'delta.current-user';
const PLATFORM_ACCESS_TOKEN_KEY = 'delta.platform.access-token';
const PLATFORM_USER_KEY = 'delta.platform.current-user';

export const authStorage = createAdminSessionStorage<CurrentUser>(sessionStorage, {
  token: ACCESS_TOKEN_KEY,
  user: USER_KEY,
}, () => window.dispatchEvent(new Event('delta:token-renewed')));

export const platformAuthStorage = createAdminSessionStorage<PlatformOperator>(sessionStorage, {
  token: PLATFORM_ACCESS_TOKEN_KEY,
  user: PLATFORM_USER_KEY,
}, () => window.dispatchEvent(new Event('delta:platform-token-renewed')));

export const api = createApiClient({
  baseURL: '/api',
  authStorage,
  unauthorizedStatuses: [],
});

export const platformApi = createApiClient({
  baseURL: '/api/platform',
  authStorage: platformAuthStorage,
  unauthorizedStatuses: [],
});

installAdminSessionRenewal(api, authStorage, [401],
  () => window.dispatchEvent(new Event('delta:unauthorized')));
installAdminSessionRenewal(platformApi, platformAuthStorage, [401, 403],
  () => window.dispatchEvent(new Event('delta:platform-unauthorized')));

for (const [client, ignoredStatuses] of [
  [api, [401]],
  [platformApi, [401, 403]],
] as const) {
  client.interceptors.response.use(undefined, (error: unknown) => {
    reportDeleteError(error, (message) => {
      Toast.error({ content: message, duration: 8, showClose: true });
    }, ignoredStatuses);
    return Promise.reject(error);
  });
}
